import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MyEvent } from '../../models/event.model';
import { TicketStatus } from '../../pages/event-ticket/event-ticket-status';
import { TicketInfo, ReservationInfo } from '../../pages/event-ticket/event-ticket.model';

@Component({
  selector: 'event-ticket-code',
  templateUrl: 'event-ticket-code.html'
})
export class EventTicketCodeComponent implements OnInit {

  @Input() event: MyEvent;
  @Input() ticketInfo: ReservationInfo;
  @Input() notOnLocation: boolean;
  @Input() isVirtualEvent: boolean;

  @Output() activateTicketChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() validateTicketChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() checkInChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  status = TicketStatus;

  email: string;
  code: string = '';

  isSameEmail: false;
  isTicketActive: false;
  isEventDay: false;

  constructor() {

  }

  ngOnInit() {
    console.log(this.isCheckInPossible());
  }

  activateTicket() {
    this.activateTicketChanged.emit(this.code.toUpperCase());
  }

  validateTicket() {
    this.validateTicketChanged.emit(this.email);
  }

  get isCodeValid() {
    return this.code.length === 5;
  }

  checkIn() {
    this.checkInChanged.emit(true);
  }

  isCheckInPossible() {
    if (this.ticketInfo) {
      const now = new Date();
      const canCheckIn = this.ticketInfo.days.find(day => this.sameDay(now, new Date(day.date.toString())));
      return canCheckIn;
    }
    return false;
  }

  sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

}



// WEBPACK FOOTER //
// ./src/components/event-ticket-code/event-ticket-code.ts